import React from "react";
import { UsersList } from "../UsersList";

export const AdministratorsList = () => <UsersList viewType="administrators" />;
